import React from 'react';
import { getTeamOverall } from '../utils/gameData';
import { TeamLogo } from './TeamLogo';
import { MapPin } from '@phosphor-icons/react';

export const TeamCard = ({ team, onClick, isSelected = false }) => {
  if (!team) return null;

  const overall = getTeamOverall(team);

  return (
    <div
      data-testid={`team-card-${team.id}`}
      onClick={() => onClick?.(team)}
      className={`
        card-surface rounded-sm cursor-pointer transition-all duration-150
        hover:border-[#FF3B30] hover:bg-[#1A1A1F]
        ${isSelected ? 'border-[#FF3B30] bg-[#1A1A1F]' : ''}
      `}
    >
      <div className="p-4">
        {/* Team badge - SVG logo */}
        <div className="w-14 h-14 mb-3">
          <TeamLogo team={team} size={56} />
        </div>

        {/* Team name */}
        <h3 className="font-heading font-bold text-white text-lg truncate mb-1">
          {team.name}
        </h3>

        {/* City / Country */}
        <div className="flex items-center gap-1.5 text-[#A0A0A5] text-sm mb-3">
          <MapPin size={14} />
          <span>{team.country ? (team.flag ? `${team.flag} ${team.country}` : team.country) : `${team.city}, Japan`}</span>
        </div>

        {/* Stats row */}
        <div className="grid grid-cols-3 gap-2 pt-3 border-t border-[#2C2C35]">
          <div className="text-center">
            <p className="font-mono text-lg font-bold text-white">{overall}</p>
            <p className="text-xs text-[#6E6E73] uppercase">Overall</p>
          </div>
          <div className="text-center">
            <p className="font-mono text-lg font-bold text-[#007AFF]">{team.formation}</p>
            <p className="text-xs text-[#6E6E73] uppercase">Formation</p>
          </div>
          <div className="text-center">
            <p className="font-mono text-lg font-bold text-white">{team.stats.points}</p>
            <p className="text-xs text-[#6E6E73] uppercase">Points</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export const TeamCardMini = ({ team, onClick, isSelected = false }) => {
  if (!team) return null;

  return (
    <button
      data-testid={`team-mini-${team.id}`}
      onClick={() => onClick?.(team)}
      className={`
        w-full text-left card-surface rounded-sm p-3 transition-all duration-150
        hover:border-[#FF3B30]
        ${isSelected ? 'border-[#FF3B30] bg-[#1A1A1F]' : ''}
      `}
    >
      <div className="flex items-center gap-3">
        <div className="w-9 h-9 flex-shrink-0">
          <TeamLogo team={team} size={36} />
        </div>
        <div className="flex-1 min-w-0">
          <p className="font-medium text-white text-sm truncate">{team.name}</p>
          <p className="text-xs text-[#6E6E73]">{team.formation}</p>
        </div>
        <span className="font-mono text-sm text-[#A0A0A5]">
          {getTeamOverall(team)}
        </span>
      </div>
    </button>
  );
};
